import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

import { Button, Input, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import {
  BGC_APPLICATION_LINKAGE_STATUS,
  BGC_APPLICATION_LINKAGE_STATUS_MESSAGES,
  PROCESS_STATUS,
  PROCESS_STATUS_MESSAGES,
} from 'utils/constants/kypStatuses'
import { SearchOutlined } from '@mui/icons-material'
import _ from 'lodash'
import  Container, { LeftWrapper, RightWrapper, styles } from './styles'
import { doesInputMatchCPFFormat } from '../../utils/functions'

const BackgroundCheckSearchBar = ({ setSearchParams }) => {
  const [searchText, setSearchText] = useState('')
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')
  const [status, setStatus] = useState(PROCESS_STATUS.ALL)
  const [applicationLinkageStatus, setApplicationLinkageStatus] = useState(BGC_APPLICATION_LINKAGE_STATUS.ALL)

  const classes = styles()

  const handleUpdateFormState = (event) => {
    const key = event.target.name || event.currentTarget.name
    const { value } = event.target
    switch (key) {
      case 'searchText':
        setSearchText(value)
        break
      case 'startDate':
        setStartDate(value)
        break
      case 'endDate':
        setEndDate(value)
        break
      case 'status':
        setStatus(value)
        break
      case 'linkageStatus':
        setApplicationLinkageStatus(value)
        break
      default:
        break
    }
  }
  const handleSubmitSearch = () => {
    const textParam = doesInputMatchCPFFormat(searchText) ? 'person_cpf' : 'person_name'
    const searchParams = {
      status: status === PROCESS_STATUS.ALL ? null : status,
      start_date: startDate || null,
      end_date: endDate || null,
      application_linkage_status: applicationLinkageStatus === BGC_APPLICATION_LINKAGE_STATUS.ALL ? null : 
        applicationLinkageStatus,
    }
    
    if (!_.isEmpty(searchText.trim())) {
      searchParams[textParam] = searchText.trim()
    }

    setSearchParams(searchParams)
  }

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault()
      handleSubmitSearch()
    }
  }

  useEffect(() => {
    if (!searchText) handleSubmitSearch()
  }, [searchText])

  useEffect(() => {
    handleSubmitSearch()
  }, [status, startDate, endDate, applicationLinkageStatus])
  return (
    <Container>
      <LeftWrapper>
        <Input
          type="search"
          name="searchText"
          placeholder="Digite o CPF ou nome da pessoa"
          value={searchText}
          onChange={handleUpdateFormState}
          onKeyUp={handleEnter}
        />
        <Button onClick={handleSubmitSearch}>
          <SearchOutlined />
        </Button>
      </LeftWrapper>
      <RightWrapper>
        <div className={classes.filterStatus}>
          <InputLabel id="linkageStatus">Aplicação:</InputLabel>
          <Select
            labelId="linkageStatus"
            id="linkageStatus"
            name="linkageStatus"
            value={applicationLinkageStatus}
            onChange={handleUpdateFormState}
            autoWidth
            variant="standard"
          >
            {
              Object.keys(BGC_APPLICATION_LINKAGE_STATUS).map((key) => (
                <MenuItem
                  key={key}
                  style={{
                    fontSize: '1.25rem',
                  }}
                  value={BGC_APPLICATION_LINKAGE_STATUS[key]}
                >
                  {BGC_APPLICATION_LINKAGE_STATUS_MESSAGES[key]}
                </MenuItem>
              ))
            }
          </Select>
        </div>
        <div className={classes.filterStatus}>
          <InputLabel id="status">Status:</InputLabel>
          <Select
            labelId="status"
            id="status"
            name="status"
            value={status}
            onChange={handleUpdateFormState}
            autoWidth
            variant="standard"
          >
            {
              Object.keys(PROCESS_STATUS).map((key) => (
                <MenuItem
                  key={key}
                  style={{
                    fontSize: '1.25rem',
                  }}
                  value={PROCESS_STATUS[key]}
                >
                  {PROCESS_STATUS_MESSAGES[key]}
                </MenuItem>
              ))
            }
          </Select>
        </div>
        <TextField
          variant="standard"
          label="Data início:"
          type="date"
          id='startDate'
          name="startDate"
          defaultValue={startDate}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={handleUpdateFormState}
        />
        <TextField
          variant="standard"
          label="Data fim:"
          type="date"
          id='endDate'
          name="endDate"
          defaultValue={endDate}
          InputLabelProps={{
            shrink: true,
          }}
          onChange={handleUpdateFormState}
        />
      </RightWrapper>
    </Container>
  )
}

BackgroundCheckSearchBar.propTypes = {
  setSearchParams: PropTypes.func.isRequired,
}

export default BackgroundCheckSearchBar
